import { render, staticRenderFns } from "./SideBarLink.vue?vue&type=template&id=638f778b&scoped=true&"
import script from "./SideBarLink.vue?vue&type=script&lang=js&"
export * from "./SideBarLink.vue?vue&type=script&lang=js&"
import style0 from "./SideBarLink.vue?vue&type=style&index=0&id=638f778b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f778b",
  null
  
)

export default component.exports